var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5933 7.57265L4.59472 2.07336C4.51892 2.02704 4.43216 2.00175 4.34335 2.00009C4.25453 1.99842 4.16688 2.02045 4.08941 2.0639C4.01193 2.10735 3.94743 2.17065 3.90254 2.2473C3.85765 2.32395 3.83398 2.41117 3.83398 2.5V13.4986C3.83398 13.5874 3.85765 13.6746 3.90254 13.7513C3.94743 13.8279 4.01193 13.8912 4.08941 13.9347C4.16688 13.9781 4.25453 14.0002 4.34335 13.9985C4.43216 13.9968 4.51892 13.9715 4.59472 13.9252L13.5933 8.42593C13.6663 8.38126 13.7267 8.31857 13.7686 8.24386C13.8105 8.16916 13.8325 8.08494 13.8325 7.99929C13.8325 7.91364 13.8105 7.82942 13.7686 7.75471C13.7267 7.68001 13.6663 7.61732 13.5933 7.57265Z",
    fill: "#1D2026"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.b4f69f77f70491a6f174115551490fbf.svg";
export { ForwardRef as ReactComponent };